import { render, staticRenderFns } from "./EfficiencyReport.vue?vue&type=template&id=64edd3a2"
import script from "./EfficiencyReport.vue?vue&type=script&lang=js"
export * from "./EfficiencyReport.vue?vue&type=script&lang=js"
import style0 from "./EfficiencyReport.vue?vue&type=style&index=0&id=64edd3a2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports